'use client';

import { Sizes, ThemeColorValueImportance } from '@actr/style/src/specs/theme-v2';
import { Button, ButtonSizes, ButtonTypes } from '@actr/ui/src/components/_atoms/button';
import { Space } from '@actr/ui/src/components/_atoms/space';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { Price } from '@actr/ui/src/components/price';
import React, { FC, useState } from 'react';

import { CheapestDirections } from '@/services/models/avia/main-page-info';

import CheapestDirectionCard from './direction-card';
import * as Styled from './style.css';

export type CheapestDirectionsBlockProps = {
  data: CheapestDirections;
};

const INITIAL_DESKTOP = 9;
const INITIAL_MOBILE = 3;
const STEP = 9;

const CheapestDirectionsBlock: FC<CheapestDirectionsBlockProps> = ({ data }) => {
  const { title, description, list } = data;
  const recommendations = list.recommendations ?? [];

  const [desktopVisibleCount, setDesktopVisibleCount] = useState(INITIAL_DESKTOP);
  const [mobileVisibleCount, setMobileVisibleCount] = useState(INITIAL_MOBILE);

  const showDesktopButton = desktopVisibleCount < recommendations.length;
  const showMobileButton = mobileVisibleCount < recommendations.length;

  function handleShowMore() {
    setDesktopVisibleCount(prev => prev + STEP);
    setMobileVisibleCount(prev => prev + STEP);
  }

  if (!recommendations.length) {
    return null;
  }

  return (
    <ContentBlock>
      <Text tagName="h3" font="title.x2l">
        {title}
        {' '}
        <Price font="title.x2l" amount={list.min_price} />
      </Text>
      <Space size={Sizes.X3S} />
      {!!description && (
        <>
          <Text color={ThemeColorValueImportance.LIGHTER} font="paragraph.m">
            {description}
          </Text>
          <Space size={Sizes.M} />
        </>
      )}
      <div className={Styled.DesktopCardsGrid}>
        {recommendations.map((item, i) => (
          <CheapestDirectionCard
            key={`${item.from}-${item.to}-${item.date}-${item.url}`}
            recommendation={item}
            isHidden={i >= desktopVisibleCount}
          />
        ))}
      </div>
      <div className={Styled.MobileCardsGrid}>
        {recommendations.map((item, i) => (
          <CheapestDirectionCard
            key={`${item.from}-${item.to}-${item.date}-${item.url}`}
            recommendation={item}
            isHidden={i >= mobileVisibleCount}
          />
        ))}
      </div>
      {showDesktopButton && (
      <Button
        className={Styled.ShowMoreDesktopButton}
        onClick={handleShowMore}
        buttonType={ButtonTypes.SECONDARY}
        size={ButtonSizes.S}>
        Ещё больше дешёвых перелётов
      </Button>
      )}
      {showMobileButton && (
      <Button
        className={Styled.ShowMoreMobileButton}
        onClick={handleShowMore}
        buttonType={ButtonTypes.SECONDARY}
        size={ButtonSizes.S}>
        Ещё больше дешёвых перелётов
      </Button>
      )}
    </ContentBlock>
  );
};

export default CheapestDirectionsBlock;
